var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-img', _vm._b({
    staticClass: "w-100",
    attrs: {
      "aspect-ratio": 232 / 68,
      "max-width": "160",
      "contain": ""
    }
  }, 'v-img', Object.assign({}, _vm.$attrs, {
    src: _vm.src
  }), false), [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.src,
      expression: "!src"
    }],
    attrs: {
      "absolute": "",
      "color": "white"
    }
  }, [_c('image-overlay')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }